export default "__VITE_ASSET__DwJtFPDK__"